import { render, staticRenderFns } from "./report-sorting.vue?vue&type=template&id=9b7f5074&"
import script from "./report-sorting.vue?vue&type=script&lang=ts&"
export * from "./report-sorting.vue?vue&type=script&lang=ts&"
import style0 from "./report-sorting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports